'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tdisplay: ', ';\n\talign-items: center;\n\tmargin-top: ', 'px;\n\tmargin-bottom: ', 'px;\n\tmargin-left: ', 'px;\n\tmargin-right: ', 'px;\n\t', '\n\t', '\n\t', '\n'], ['\n\tdisplay: ', ';\n\talign-items: center;\n\tmargin-top: ', 'px;\n\tmargin-bottom: ', 'px;\n\tmargin-left: ', 'px;\n\tmargin-right: ', 'px;\n\t', '\n\t', '\n\t', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\tappearance: none;\n\tposition: relative;\n\tfloat: ', ';\n\theight: 30px;\n\twidth: 60px;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\toutline: none;\n\tmargin: 0;\n\tcursor: pointer;\n\ttransition: all 0.2s ease-in-out;\n\t&::before {\n\t\tcontent: \'\';\n\t\tbackground: ', ';\n\t\tborder-radius: ', ';\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tposition: absolute;\n\t\tleft: 0px;\n\t\ttop: 2px;\n\t\ttransform: translateX(2px);\n\t\ttransition: all 0.2s ease-in-out;\n\t}\n    &:checked {\n\t\tbackground: ', ';\n\t\tborder-color: ', ';\n\t\t&::before {\n\t\t\tbackground: ', ';\n\t\t\ttransform: translateX(31px);\n\t\t}\n\t}\n\t', '\n\t&:disabled {\n\t\tpointer-events: none;\n\t\tbackground: ', ';\n\t\tborder-color: ', ';\n\t\t&::before {\n\t\t\tbackground: ', ';\n\t\t}\n\t};\n'], ['\n\tappearance: none;\n\tposition: relative;\n\tfloat: ', ';\n\theight: 30px;\n\twidth: 60px;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\toutline: none;\n\tmargin: 0;\n\tcursor: pointer;\n\ttransition: all 0.2s ease-in-out;\n\t&::before {\n\t\tcontent: \'\';\n\t\tbackground: ', ';\n\t\tborder-radius: ', ';\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tposition: absolute;\n\t\tleft: 0px;\n\t\ttop: 2px;\n\t\ttransform: translateX(2px);\n\t\ttransition: all 0.2s ease-in-out;\n\t}\n    &:checked {\n\t\tbackground: ', ';\n\t\tborder-color: ', ';\n\t\t&::before {\n\t\t\tbackground: ', ';\n\t\t\ttransform: translateX(31px);\n\t\t}\n\t}\n\t', '\n\t&:disabled {\n\t\tpointer-events: none;\n\t\tbackground: ', ';\n\t\tborder-color: ', ';\n\t\t&::before {\n\t\t\tbackground: ', ';\n\t\t}\n\t};\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _label = require('../text/label');

var _label2 = _interopRequireDefault(_label);

var _multilink = require('../multilink');

var _multilink2 = _interopRequireDefault(_multilink);

var _colors = require('../../constants/colors');

var _sizes = require('../../constants/sizes');

var _alignments = require('../../constants/alignments');

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SwitchWrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
	var inline = _ref.inline;
	return inline ? 'inline-flex' : 'flex';
}, function (_ref2) {
	var top = _ref2.top;
	return (0, _getSize2.default)(top);
}, function (_ref3) {
	var bottom = _ref3.bottom;
	return (0, _getSize2.default)(bottom);
}, function (_ref4) {
	var left = _ref4.left;
	return (0, _getSize2.default)(left);
}, function (_ref5) {
	var right = _ref5.right;
	return (0, _getSize2.default)(right);
}, function (_ref6) {
	var horizontalAlignment = _ref6.horizontalAlignment,
	    inline = _ref6.inline;
	return horizontalAlignment === _alignments.Alignments.left && (inline ? "justify-content: left;" : "align-items: left;");
}, function (_ref7) {
	var horizontalAlignment = _ref7.horizontalAlignment,
	    inline = _ref7.inline;
	return horizontalAlignment === _alignments.Alignments.center && (inline ? "justify-content: center;" : "align-items: center;");
}, function (_ref8) {
	var horizontalAlignment = _ref8.horizontalAlignment,
	    inline = _ref8.inline;
	return horizontalAlignment === _alignments.Alignments.right && (inline ? "justify-content: flex-end;" : "align-items: flex-end;");
});

var SwitchComponent = _styledComponents2.default.input(_templateObject2, function (_ref9) {
	var textAlign = _ref9.textAlign;
	return textAlign === 'left' ? 'right' : 'left';
}, _colors.Colors.LightMode, _colors.Colors.StrokeDark, function (_ref10) {
	var square = _ref10.square;
	return square ? '3px' : '20px';
}, _colors.Colors.StrokeDark, function (_ref11) {
	var square = _ref11.square;
	return square ? '10%' : '50%';
}, _colors.Colors.Primary, _colors.Colors.Primary, _colors.Colors.LightMode, function (_ref12) {
	var isDesktop = _ref12.isDesktop;
	return isDesktop && '\n\t&:hover:not(:checked) {\n\t\tbackground: ' + _colors.Colors.LightMode + ';\n\t\tborder-color: ' + _colors.Colors.Secondary + ';\n\t\t&:before {\n\t\t\tbackground: ' + _colors.Colors.Secondary + ';\n\t\t}\n\t}\n\t';
}, _colors.Colors.LightMode, _colors.Colors.StrokeVeryDark, _colors.Colors.StrokeVeryLight);

var Switch = function (_Component) {
	_inherits(Switch, _Component);

	function Switch() {
		var _ref13;

		var _temp, _this, _ret;

		_classCallCheck(this, Switch);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref13 = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref13, [this].concat(args))), _this), _this.handleClick = function () {
			if (_this.props.disabled || _this.props.readonly) {
				return;
			}

			_this.props.clickEvent(!_this.props.value);
		}, _this.getText = function (textPosition, targets) {
			if (textPosition === 'Left') {
				if (targets != "") {
					return _react2.default.createElement(_multilink2.default, {
						textAlign: _alignments.Alignments.right,
						href: targets, newTab: true,
						text: _this.props.textLeft
					});
				} else {
					return _react2.default.createElement(_label2.default, {
						textAlign: _alignments.Alignments.right,
						text: _this.props.textLeft
					});
				}
			} else {
				if (targets != "") {
					return _react2.default.createElement(_multilink2.default, {
						textAlign: _alignments.Alignments.left,
						href: targets, newTab: true,
						text: _this.props.text
					});
				} else {
					return _react2.default.createElement(_label2.default, {
						textAlign: _alignments.Alignments.left,
						text: _this.props.text
					});
				}
			}

			return;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Switch, [{
		key: 'render',
		value: function render() {

			var textLeft = this.getText('Left', this.props.targetsLeft || "");
			var textRight = this.getText('Right', this.props.targets || "");

			var componentAlignment = _alignments.Alignments.center;

			return _react2.default.createElement(
				SwitchWrapper,
				_extends({
					inline: true,
					horizontalAlignment: componentAlignment,
					isChecked: this.props.value
				}, this.props),
				_react2.default.createElement(
					_row2.default,
					null,
					_react2.default.createElement(
						_column2.default,
						{ nogutter: true },
						_react2.default.createElement(
							_container2.default,
							{ inline: true },
							this.props.textLeft && _react2.default.createElement(
								_container2.default,
								null,
								textLeft
							),
							_react2.default.createElement(
								_container2.default,
								{ left: this.props.textLeft && _sizes.Sizes.sm, right: this.props.text && _sizes.Sizes.sm },
								_react2.default.createElement(SwitchComponent, {
									onClick: this.handleClick,
									disabled: this.props.disabled,
									readonly: this.props.readonly,
									type: 'checkbox',
									value: this.props.value,
									checked: this.props.value,
									textAlign: this.props.textAlign,
									square: this.props.square,
									isDesktop: this.context.screen.isDesktop
								})
							),
							this.props.text && _react2.default.createElement(
								_container2.default,
								null,
								textRight
							)
						)
					)
				)
			);
		}
	}]);

	return Switch;
}(_react.Component);

Switch.contextTypes = {
	screen: _propTypes2.default.object
};

exports.default = Switch;